import { Box, Typography } from '@mui/material';
import { observer } from 'mobx-react';
import React from 'react';

import { Colors } from '../../../design/color/Colors';
import { IUnitModel } from '../../../../service/unit/interface/IUnitModel';

export interface IUnitListAdminCardProperties {
  unit: IUnitModel;
  applicationId: string;
  isRequired: boolean;
}

export const UnitListAdminCard = observer(({ unit, isRequired }: IUnitListAdminCardProperties) => {
  return (
    <Box
      sx={{
        padding: '8px 10px 8px 16px',
        display: 'flex',
        justifyContent: 'space-between',
        background: isRequired ? Colors.withOpacity(Colors.primaryActive, 0.3) : Colors.bgSurface,
        alignItems: 'center',
        width: '100%',
        borderRadius: '8px',
      }}
    >
      <Typography sx={{ cursor: 'pointer' }}>{unit.settings.titleHeading}</Typography>
    </Box>
  );
});
